export const styles = () => ({
  assetName: {
    fontWeight: "bold",
    fontSize: 12,
  },
  type: {
    fontSize: 10,
  },
});
